import Typography from "../../../../componentsNew/Typography";
import ProgressBar from "../../../../componentsNew/ProgressBar";
import IconStatus from "../CardDashGrafico/IconStatus";

export function ProgressBarIconNota({ nota, mudanca = 0 }) {
    return (
        <div className="flex flex-col w-full">
            <div className="w-full flex">
                <div className="w-5/6 flex items-center mr-2">
                    <ProgressBar nota={nota?.toFixed(0) / 100} pequeno />
                </div>
                {nota?.toFixed(1)}
            </div>
            <div className="flex">
                <IconStatus mudancaPorcentagem={mudanca} />
                <Typography component="base" className="ml-2 text-[0.55em] font-bold">{mudanca > 0 && "+"}{mudanca?.toFixed(2)}% desde a última atualização</Typography>
            </div>
        </div>
    )
}
